export default "__VITE_ASSET__6a07y4wT__"